module.exports = __webpack_public_path__ + "img/hjk.d2efb0f9.png";